export default "__VITE_ASSET__DKh7jSD4__"